module.exports = __webpack_public_path__ + "static/battle_14-a3a0653ffb3a18961b1efa68a9e62820.jpg";